// extracted by mini-css-extract-plugin
module.exports = {"root":"_27Yvh","iframe":"_3_OC7"};